import { UserSession } from '../../contexts/auth/types';
import { apolloClient } from '../apollo';
import MutationSubscribeToMailchimp from './subscribe-to-mailchimp.graphql';

export const subscribeToMailchimpList = async (session: UserSession | null, email: string) => {
	const { data: subscribeData } = await apolloClient.mutate({
		mutation: MutationSubscribeToMailchimp,
		variables: {
			email,
		},
		context: { accessToken: session?.accessToken },
	});

	if (!subscribeData.subscribeToMailchimp) throw new Error('Failed to create membership');
};
